//API ERROR
export const MSG_DEFAULT_ERROR = "An error occured. Please try again.";
export const MSG_ADDED_MANUAL_VOTES = "Manual has been successfully update.";
export const MSG_CONTACT_ADMIN = "An error occured. Please contact administrator.";
export const MSG_ERROR = "Oops something went wrong... Please contact administrator.";
export const MSG_CLICK_TRY_AGAIN = "Click to try again";

//FORM ERRORS
export const MSG_EMPTY_REQUIRED = "This field should not be empty.";
export const MSG_GREATER_ENDDATE = "End date should be greater or equal to start date";
export const MSG_LESSER_ENDTIME = "End date time should be greater or equal to start date time";
export const MSG_EXCEEDS_CHARACTER = "Value exceeds allowed characters.";
export const MSG_INVALID_END_DATE = "Payment should not be greater than the subscription end date";
export const MSG_GREATER_ZERO = "Value should be greater than 0.";
export const MSG_EXCEED_NUMBER = "Value exceeds allowed value.";
export const MSG_NEGATIVE_VALUES = "Negative values are not allowed.";
export const MSG_PASSWORD_LEAST_SIX = "Password should be at least 6 characters.";
export const MSG_INVALID_EMAIL = "Email is not valid."
export const MSG_INVALID_NUMBER = "Invalid number format."
export const MSG_FIELD_NOT_NUMBER = "Field must be a number."
export const PRIMARY_USER_ALREADY_EXISTS = "Company code has a primary user.";
export const MSG_INVALID_IMAGE_TYPE = "Invalid image file format."
export const MSG_EXCEEDS_TICKET_LIMIT = "Exceeds max allowable reservation";

//GENERAL
export const DELETE_MESSAGE = "Are you sure you want to delete this record?";
export const IMAGE_SIZE_MESSAGE = "Image size must be less than 4 mb.";
export const SAVE_CHANGES = "Save Changes";
export const APPROVE = "Are you sure you want to approve this record?";
export const INVALID_REQUEST = "Invalid request. Please try again."
export const RECOMMENENDED_SIZE = "Recommended size: 600 x 600";
export const RECOMMENDED_SIZE_700 = "Recommended size: 700 x 300";
export const CANNOT_DELETE_SHSAA = "Cannot remove SHS-ADCAA Record.";
export const INVALID_REQ = "Invalid Request";
export const PAGE_LOADING = "Loading. . .";

//ADVERTISEMENT
export const ADS_IMAGE_REQUIRED = "Advertisement image is required";
export const DELETE_ADS = "Delete Advertisement";
export const APPROVE_ADS = "Approve Advertisement";
export const DECLINE_PENDING_ADS = "Decline Pending Advertisement";
export const DECLINE_ADS = "Are you sure you want to decline this record?";

//MEMBER 
export const MSG_EXPORT = "Successfully Exported";
export const MSG_REMOVE = "Cannot remove logged-in user."
export const DELETE_MEMBER = "Delete Member";
export const PROFILE_IMAGE_REQUIRED = "Profile image is required";
export const PROOF_IMAGE_REQUIRED = "Proof image is required.";

//POPUP CONFIRMATION
export const MSG_CONFIRM_CHANGES = "Do you want to save changes?";
export const MSG_CONFIRM_DONATION = "Do you want to send this pledge?";
export const MSG_CONFIRM_RESERVATION = "Do you want to save reservation?";

//REDEEM GUIDE
export const MSG_REDEEM_GUIDE = "Setting the value to 0 indicates that there is no redemption limit per member."

//POLL EMAIL SUCCESS
export const MSG_ONLINE_VOTES_SENT_EMAIL = "Online votes results has been successfully sent."
export const MSG_FINAL_VOTES_SENT_EMAIL = "Final votes results has been successfully sent."

//STORES
export const DISABLED_DRAGGING = "Dragging is disabled on search mode";
export const REARRANGE_DRAGGING = "Drag to rearrange order seen in mobile app";
export const ALLOW_REDEMPTION = "(this code will be used by the store to allow redemption)";

//POPUP ANNOUNCEMENTS
export const DELETE_POPUP = "Delete Announcement";

//MOBILE NOTIFICATIONS
export const CONFIRM_SEND = "Send Mobile Push Notification";
export const SEND_PUSH_NOTIF_MESSAGE = "Are you sure you want to send this Notification to all users?";

//CALENDAR
export const DELETE_CALENDAR = "Delete Event";

//DONATIONS

export const INVALID_REQUEST_TO_WEBSITE = "Invalid request to website.";

//DONATION RESPONSE

export const SUCCESS_RESPONSE = "Thank you for your Donation!";
export const RESPONSE_BODY = "Thank you for donating to the Sacred Heart School - Ateneo De Cebu Alumni Association. We will contact you directly regarding your donation.";


//RESERVATION RESPONSE
export const RESERVED_SUCCESSFULLY = "Reserved Successfully!";
export const RESERVATION_BODY = "Thank you for your reservation. SHS-ADCAA representatives will contact you immediately regarding your reservation.";


//GENERIC DONATION 

export const GENERIC_DONATION_TITLE = "SHS-ADC Alumni Association Donation Pledge";
export const GENERIC_DONATION_DESCRIPTION = `<br/>Your pledge will be of great help to the future activities and advocacies of the alumni association as we are men and women for others.<br/><br/> Upon submission of pledge, the alumni association will contact you for further instructions
as to how your pledge will be processed. Thank you for your generosity and support to the alumni association.`

//LOGIN

export const INCORRECT_CREDENTIALS = "Incorrect username/password.";


//RESET PASSWORD

export const PASSWORD_INVALID_LENGTH = "Password should be 6-20 characters";
export const PASSWORD_MISMATCH = "Password mismatch";
export const REDIRECT = "Password successfully updated!\nYou will be redirected to the SHS-ADCAA facebook page.";
export const SHSAA_WEBSITE = "https://www.facebook.com/SHSALUMNI/";

//MANUAL VOTES 

export const MANUAL_VOTES_ERROR = "Manual vote must not be greater than 1,000,000"

//POLL ELECTION RESULT
export const CANDIDATE_IMAGE_REQUIRED = "Candidate image is required";

//POLL
export const DELETE_POLL = "Delete Poll";
export const POLL_IMAGE_REQUIRED = "Poll image is required";

//POLLSELECTION
export const DELETE_POLLSELECTION = "Delete Poll Selection";

//POLL SELECTION CHOICE
export const CHOICE_EMPTY = "Choice must not be empty";
export const DELETE_POLLCHOICE = "Delete Poll Choice";

//RESERVATION
export const CONFIRM_RESERVATION = "Confirm Reservation";

//STORES
export const STORE_IMAGE_REQUIRED = "Store image is required";

//PAYPAL
export const SUBSCRIPTION_TITLE= "Subscription"
export const CANCEL_SUBSCRIPTION = "Do you want to cancel subscription ?"
export const ACTIVATE_SUBSCRIPTION = "Do you want to reactivate subscription ?"